'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { REMOVE_FROM_LANGUAGE_GROUP } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { receiveContent, requestContent, requestedContentFailed, requestedRemoveFromLanguageGroupSuccess, requestedRemoveFromLanguageGroupFailure, requestRemoveFromLanguageGroup } from '../actions/ContentActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(REMOVE_FROM_LANGUAGE_GROUP).pipe(mergeMap(({
  payload: {
    contentType,
    id
  }
}) => ContentClient.removeFromLanguageGroup(contentType, id).pipe(mergeMap(() => ContentClient.fetchContent({
  contentPageId: id,
  contentType
}).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedRemoveFromLanguageGroupSuccess(contentType))), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()))), catchError(error => of(requestedRemoveFromLanguageGroupFailure(error, contentType))), startWith(requestRemoveFromLanguageGroup())))));